




























import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldSponsorPrimaryDomains'

  vue:
    props: ['value', 'errors', 'options']

    data: ->
      primaryDomains: @value || []

    computed:
      sponsorSetOptions: ->
        @options || []

    methods:
      hiMarkSponsorSetAsPrimary: (sponsor) ->
        @primaryDomains = Array.from(new Set([...@primaryDomains, sponsor.domain]))
        @inputChanged()

      hiUnmarkSponsorSetAsPrimary: (sponsor) ->
        @primaryDomains = @primaryDomains.filter((domain) => domain isnt sponsor.domain)
        @inputChanged()

      inputChanged: ->
        @$emit 'input', @primaryDomains
        @$emit 'change', @primaryDomains

export default VueOptions.vue settings
